import { SAMPLE_RESUME_OPTIONS } from "@/constants/data/sampleResume/sampleResumeOptions";
import type { FileWithPath } from "@mantine/dropzone";
import { z } from "zod";

export const aiDocumentSelectionFormMethodSchema = z.enum([
	"dummyResume",
	"fileUpload",
	"textInput",
]);

export const aiDocumentSelectionFormSchema = z.discriminatedUnion("method", [
	z.object({
		method: z.literal(aiDocumentSelectionFormMethodSchema.enum.dummyResume),
		label: z
			.enum([
				SAMPLE_RESUME_OPTIONS[0].items[0].label,
				SAMPLE_RESUME_OPTIONS[0].items[1].label,
				SAMPLE_RESUME_OPTIONS[0].items[2].label,
				SAMPLE_RESUME_OPTIONS[0].items[3].label,
				...SAMPLE_RESUME_OPTIONS.slice(1).flatMap((option) =>
					option.items.map((item) => item.label),
				),
			])
			.optional()
			.refine((value) => value, {
				message: "サンプルレジュメを選択してください",
			}),
	}),
	z.object({
		method: z.literal(aiDocumentSelectionFormMethodSchema.enum.fileUpload),
		file: z.custom<FileWithPath | undefined>().refine((value) => value, {
			message: "履歴書または職務経歴書をアップロードしてください",
		}),
	}),
	z.object({
		method: z.literal(aiDocumentSelectionFormMethodSchema.enum.textInput),
		textInput: z
			.string({
				required_error: "スキル・経歴等を入力してください",
			})
			.trim()
			.min(100, {
				message: "スキル・経歴等は100文字以上入力してください",
			})
			.max(10000, {
				message: "10000文字以内で入力してください",
			}),
	}),
]);

export type AiDocumentSelectionForm = z.infer<
	typeof aiDocumentSelectionFormSchema
>;
